export default __webpack_public_path__ + "static/DanzzaBold-e6043f52f75044ea1c8fdfdd1b37dd01.woff";